<!--
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2020-02-06 14:32:29
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2020-02-12 13:25:55
 -->
<template>
  <div class="my-tab">
    <div class="tab-list">
      <div
        v-for="item in tabList"
        :key="item.id"
        :class="{activeClass:aim == item.id}"
        @click="clickTab(item.id, item.name)"
      >{{ item.name }}</div>
    </div>
    <div class="divide"></div>
  </div>
</template>

<script>
export default {
  props: ["tabList"],
  data() {
    return {
      aim: 0
    };
  },
  mounted() {
    this.aim = this.tabList[0].id;
  },
  methods: {
    clickTab(id, name) {
      this.aim = id;
      name === "各校动态"
        ? this.$emit("getSchoolTabList", id)
        : this.$emit("toggleTab", id);
    }
  }
};
</script>

<style lang="scss">
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}
.my-tab {
  .tab-list {
    display: flex;
    height: 45px;
    @include font-style(
      "PingFangSC-Regular",
      20px,
      rgba(136, 136, 136, 1),
      400
    );
    line-height: 28px;
    div {
      height: 100%;
      margin-right: 40px;
      cursor: pointer !important;
    }
    div.activeClass {
      @include font-style(
        "PingFangSC-Semibold",
        20px,
        rgba(197, 46, 15, 1),
        600
      );
      border-bottom: 2px solid rgba(197, 46, 15, 1);
    }
  }
  .divide {
    width: 100%;
    height: 2px;
    background-color: #dbdbdb;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tab.vue